module.exports = __webpack_public_path__ + "img/logo-lueneburg-large@2x.9f36f408.png";